var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3332 16C29.3332 23.3638 23.3636 29.3334 15.9998 29.3334C8.63604 29.3334 2.6665 23.3638 2.6665 16C2.6665 8.63622 8.63604 2.66669 15.9998 2.66669C23.3636 2.66669 29.3332 8.63622 29.3332 16ZM18.5648 12.5011C18.4975 12.6621 18.3988 12.8081 18.2745 12.9307L15.1718 16.0067L18.2625 19.0693C18.3868 19.1919 18.4855 19.3379 18.5528 19.499C18.6202 19.66 18.6549 19.8328 18.6549 20.0073C18.6549 20.1819 18.6202 20.3547 18.5528 20.5157C18.4855 20.6768 18.3868 20.8228 18.2625 20.9453C18.0104 21.1945 17.6703 21.3342 17.3158 21.3342C16.9614 21.3342 16.6213 21.1945 16.3692 20.9453L12.4292 17.0387C12.2929 16.9036 12.1848 16.7428 12.111 16.5657C12.0371 16.3886 11.9991 16.1986 11.9991 16.0067C11.9991 15.8148 12.0371 15.6248 12.111 15.4477C12.1848 15.2705 12.2929 15.1098 12.4292 14.9747L16.3825 11.0547C16.6345 10.8059 16.9744 10.6664 17.3285 10.6664C17.6826 10.6664 18.0225 10.8059 18.2745 11.0547C18.3988 11.1772 18.4975 11.3233 18.5648 11.4843C18.6322 11.6453 18.6669 11.8181 18.6669 11.9927C18.6669 12.1672 18.6322 12.34 18.5648 12.5011Z",
    fill: "#091E42",
    fillOpacity: 0.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftCircle);
export default __webpack_public_path__ + "static/media/chevron-left-circle.36219bfaa37f175bf106d3113d227375.svg";
export { ForwardRef as ReactComponent };